import { groupBy } from "lodash";
import { API_URL } from "../config/config";
import { getRequest, putRequest } from "../utils/axiosUtils";
import buildQueryParams from "../utils/buildQueryParams";

export const fetchReportStats = async (filter, setReportStats) => {
    const { country, state, city, gender, statusFilter } = filter;

    const queryParams = buildQueryParams({
        country,
        state,
        city,
        gender,
        statusFilter,
    });

    const res = await getRequest({
        url: `${API_URL}/admin/user/reports/stats?${queryParams}`,
    });
    if (!res) return
    if (res.status >= 200 && res.status < 300 && res.data) {
        setReportStats(res.data);
    } else {
        throw new Error(`Unexpected response code: ${res.status}`);
    }
};

export const fetchReportUsersList = async ({
    filter,
    setReportUsersData,
    page,
    limit,
    skip,
    statusFilter,
    searchTerm,
    groupBy = 'reportedUser'
}) => {
    const { country, state, city, gender } = filter;

    const queryParams = buildQueryParams({
        country,
        state,
        city,
        gender,
        statusFilter,
        page,
        limit,
        skip,
        searchTerm
    });

    const res = await getRequest({
        url: `${API_URL}/admin/user/reports/${groupBy}?${queryParams}`,
    });
    if (!res) return
    if (res.status >= 200 && res.status < 300 && res.data) {
        setReportUsersData(res?.data?.reports);
        return res.data;
    } else {
        throw new Error(`Unexpected response code: ${res.status}`);
    }
};

export const getReportsByUserId = async ({
    userId,
    filter,
    setData,
    page,
    limit,
    skip,
    statusFilter,
    searchTerm,
    groupBy = 'reportedUser'
}) => {
    // const { country, state, city, dateRange, gender } = filter;

    // const queryParams = buildQueryParams({
    //     country,
    //     state,
    //     city,
    //     gender,
    //     dateRange,
    //     statusFilter,
    //     page,
    //     limit,
    //     skip,
    //     searchTerm
    // });

    try {
        const res = await getRequest({
            url: `${API_URL}/admin/user/reports?userId=${userId}&type=${groupBy}`,
        });
        if (!res) return
        if (res.status >= 200 && res.status < 300 && res.data) {
            setData(res?.data?.reports);
            return res.data.data;
        } else {
            throw new Error(`Unexpected response code: ${res.status}`);
        }
    } catch (error) {
        console.error('Error fetching reports by userId:', error);
        throw new Error(error.message || 'Error fetching reports');
    }
};

export const updateReportStatus = async ({
    reportId,
    status
}) => {
    try {
        const res = await putRequest({
            url: `${API_URL}/admin/user/report/${reportId}`,
            data: {
                reportId,
                status
            }
        });

        if (res.status >= 200 && res.status < 300 && res.data) {
            return res.data;
        } else {
            throw new Error(`Unexpected response code: ${res.status}`);
        }
    } catch (error) {
        console.error('Error updating report status:', error);
        throw new Error(error.message || 'Error updating report status');
    }
};